/* unplugin-vue-components disabled */import { render } from "./TeacherList.vue?vue&type=template&id=8c2602de&scoped=true"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"

import "./TeacherList.vue?vue&type=style&index=0&id=8c2602de&lang=css"
import "./TeacherList.vue?vue&type=style&index=1&id=8c2602de&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2602de"]])

export default __exports__